import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './tour_detailsstyles.css';
import naranImg1 from '../assets/naran1.jpg';
import naranImg2 from '../assets/naran2.jpg';
import naranImg3 from '../assets/naran3.jpg';

const TourDetail2 = () => {
  const [activeImage, setActiveImage] = useState(naranImg1);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const navigate = useNavigate();

  const images = [naranImg1, naranImg2, naranImg3];

  const handleImageClick = (index) => {
    setActiveImage(index);
  };

  const handlePackageSelect = (packageData) => {
    const tourData = {
      ...packageData,
      tour_name: 'Explore the Majestic Gilgit'  // Add the tour name here
    };
    setSelectedPackage(tourData);
    navigate('/booking', { state: { packageData: tourData } });  // Pass the updated packageData
  };

  return (
    <div className="tour-details">
      <div className="tour-header">
        <h1>Naran & Kaghan Valley Adventure</h1>
        <p><strong>Description:</strong> Explore the stunning landscapes of Naran & Kaghan, known for their scenic beauty, lush green meadows, and crystal-clear lakes.</p>
      </div>

      {/* Overview Section */}
      <section className="overview">
        <h2>Overview</h2>
        <p>Naran & Kaghan Valley offer a perfect getaway into nature with breathtaking views and serene landscapes...</p>
      </section>

      {/* Gallery Section */}
      <section className="gallery">
        <h2>Gallery</h2>
        <div className="image-gallery">
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Naran & Kaghan ${index + 1}`}
              onClick={() => handleImageClick(index)}
              className={index === activeImage ? 'active' : ''}
            />
          ))}
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing">
        <h2>Pricing</h2>
        <div className="pricing-details">
          <div className="price-item">
            <h3>Standard Package</h3>
            <p><strong>Price:</strong> PKR 50,000 per person</p>
            <p>
              <strong>Details:</strong> Accommodation in 3-star hotels, guided tours, and transportation in a private SUV. Breakfast and dinner are included. Duration: 5 days.
              <br />
              <strong>Visiting Spots:</strong> Saif-ul-Malook Lake, Babusar Top, Lulusar Lake, Ansoo Lake.
            </p>
            <button onClick={() => handlePackageSelect({
              name: 'Standard Package',
              price: 'PKR 50,000 per person',
              duration: '5 days',
              accommodation: '3-star hotels',
              transportation: 'Private SUV',
              facilities: [
                'Guided tours and transportation',
                'Breakfast and Dinner included'
              ],
              spots: ['Saif-ul-Malook Lake', 'Babusar Top', 'Lulusar Lake', 'Ansoo Lake']
            })} className="book-now-btn">Select Package</button>
          </div>
          <div className="price-item">
            <h3>Deluxe Package</h3>
            <p><strong>Price:</strong> PKR 75,000 per person</p>
            <p>
              <strong>Details:</strong> Accommodation in 5-star hotels, all-inclusive meals, private guided tours, and luxury transportation in a private SUV. Duration: 5 days.
              <br />
              <strong>Visiting Spots:</strong> Saif-ul-Malook Lake, Babusar Top, Lulusar Lake, Ansoo Lake.
            </p>
            <button onClick={() => handlePackageSelect({
              name: 'Deluxe Package',
              price: 'PKR 75,000 per person',
              duration: '5 days',
              accommodation: '5-star hotels',
              transportation: 'Private SUV',
              facilities: [
                'All-inclusive meals',
                'Private guided tours and luxury transportation'
              ],
              spots: ['Saif-ul-Malook Lake', 'Babusar Top', 'Lulusar Lake', 'Ansoo Lake']
            })} className="book-now-btn">Select Package</button>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <h2>Testimonials</h2>
        <blockquote>
          "An amazing trip! The natural beauty of Naran & Kaghan is unparalleled."
          <cite> - Sarah Khan</cite>
        </blockquote>
        <blockquote>
          "A wonderful experience with top-notch service."
          <cite> - Ahmed Ali</cite>
        </blockquote>
      </section>

      {/* Map Section */}
      <section className="map">
        <h2>Map</h2>
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10481253.764058735!2d71.79380543714525!3d34.83901214212221!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfe2f9d8e7aeef%3A0xc12d8bda8f8f3ec3!2sNaran%20Valley%2C%20Pakistan!5e0!3m2!1sen!2s!4v1693385878332!5m2!1sen!2s"
          width="100%" 
          height="450" 
          style={{ border: 0 }} 
          allowFullScreen="" 
          loading="lazy" 
          title="Naran Kaghan Map">
        </iframe>
      </section>

      {/* FAQs Section */}
      <section className="faqs">
        <h2>FAQs</h2>
        <details>
          <summary>What is included in the tour package?</summary>
          <p>The package includes accommodation, meals, guided tours, and transportation within Naran & Kaghan.</p>
        </details>
        <details>
          <summary>What should I pack for the trip?</summary>
          <p>Pack warm clothing, comfortable shoes for trekking, and a camera to capture the stunning scenery.</p>
        </details>
        <details>
          <summary>How do I book the tour?</summary>
          <p>You can book the tour through our website or contact our customer support for assistance.</p>
        </details>
      </section>

      <section className="contact-info">
        <h2>Contact Information</h2>
        <p>For more details or to book your tour, contact us at <a href="tel:+1234567890">(123) 456-7890</a> or email us at <a href="mailto:info@travelsite.com">info@travelsite.com</a>.</p>
      </section>
      
    </div>
  );
}

export default TourDetail2;
